<template>
<div class="chapter">
<div class="inner_page">
<p style="font-weight: bold; text-align: center; text-indent: 0">Παιδικό βιβλίο με φωτογραφίες για τη γλώσσα του σώματος των σκύλων </p>
<h5><a id="TOC" style="font-style: italic">Σύμβαλε στη διατήρηση της ασφάλειας των παιδιών</a></h5>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c001.vue?3c21ebe2